export const EM_FETCH_STATUS = {
  LOADING: 'LOADING',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
} as const;

export default {
  EM_FETCH_STATUS,
};
